// FIXME Use the new AssetType.js
export const BABY = 'BABY';
export const CAR = 'CAR';
export const KICKSCOOTER = 'KICKSCOOTER';
export const SCOOTER = 'SCOOTER';
export const MAINTENANCE = 'MAINTENANCE';
export const CRITICALFUEL = 'CRITICALFUEL';
